// components/redirects/CategoryRedirect.jsx
import { Navigate, useParams } from "react-router-dom";

function CategoryRedirect() {
  const { main_category_url, category_url } = useParams();

  return <Navigate to={`/${main_category_url}/${category_url}`} replace />;
}

export default CategoryRedirect;
